import type { TypographyProps } from "@mui/material";
import { Typography } from "@mui/material";
import type { TOptions } from "i18next";
import { useTranslation } from "react-i18next";

import type { TranslationKey } from "@thalamos/vision-common";

export type TypographyI18NProps = Omit<TypographyProps, "children"> & {
  translationKey: TranslationKey;
  translationOptions?: TOptions;
};

export function TypographyI18N({
  translationKey,
  translationOptions,
  ...props
}: TypographyI18NProps) {
  const { t } = useTranslation();
  return (
    <Typography {...props}>{t(translationKey, translationOptions)}</Typography>
  );
}
